import { ApolloClient, InMemoryCache, NormalizedCacheObject } from '@apollo/client';

// eslint-disable-next-line no-underscore-dangle
let _apolloClient: ApolloClient<NormalizedCacheObject>;

/**
 * Gets existing ApolloClient instance or create a new one
 * @returns {ApolloClient}
 */
export function getApolloClient(): ApolloClient<NormalizedCacheObject> {
  if (!_apolloClient) {
    const client = new ApolloClient({
      uri: `${import.meta.env.VITE_APP_ACCOUNTS_API_URL}/v2/graphql/query`,
      cache: new InMemoryCache(),
    });

    _apolloClient = Object.assign(client);
  }

  return _apolloClient;
}
